
(function(){
  var KEY='mz_wishlist';
  function getWL(){try{return JSON.parse(localStorage.getItem(KEY)||'[]');}catch(e){return[];}}
  function saveWL(a){try{localStorage.setItem(KEY,JSON.stringify(a));}catch(e){}}
  function count(){return getWL().length;}

  // Crée mzToggleWish uniquement si absent (theme.liquid le définit déjà).
  if(!window.mzToggleWish){
    window.mzToggleWish=function(btn){
      var h=btn.getAttribute('data-handle');if(!h)return;
      var wl=getWL(),i=wl.findIndex(function(p){return p.handle===h;});
      if(i>-1){wl.splice(i,1);btn.classList.remove('is-liked');}
      else{wl.push({handle:h,title:btn.getAttribute('data-title'),image:btn.getAttribute('data-image'),price:parseInt(btn.getAttribute('data-price'),10),variant_title:''});btn.classList.add('is-liked');}
      saveWL(wl);btn.classList.remove('pop');void btn.offsetWidth;btn.classList.add('pop');
      window.dispatchEvent(new CustomEvent('mz:wishlist:updated',{detail:{handle:h,added:btn.classList.contains('is-liked')}}));
    };
  }

  var SEL='.npc-product-wish[data-handle],.cs-product-wish[data-handle],.mz-heart-btn[data-handle],.nautiya-card__heart[data-handle],.gpg__heart[data-handle],.mzso-wish[data-handle]';
  function syncHearts(){
    var wl=getWL();
    document.querySelectorAll(SEL).forEach(function(btn){
      var liked=wl.some(function(p){return p.handle===btn.getAttribute('data-handle');});
      // classList.toggle n'écrit pas si l'état est déjà bon → aucune mutation inutile.
      btn.classList.toggle('is-liked',liked);
    });
  }

  function updateCount(){
    var n=count(), s=String(n);
    document.querySelectorAll('[data-wishlist-count]').forEach(function(el){
      // 2026-08-20 : écriture CONDITIONNELLE. C'était la source de la boucle infinie.
      if(el.textContent!==s){ el.textContent=s; }
      el.classList.toggle('is-visible',n>0);
    });
    document.querySelectorAll('.nty-wishlink').forEach(function(l){l.classList.toggle('is-active',n>0);});
  }

  // Attache un badge compteur aux liens wishlist EXISTANTS du header (sans duplication).
  function decorateExistingLinks(){
    var links=document.querySelectorAll('a[href="/pages/wishlist"],a[href*="/pages/wishlist"]');
    links.forEach(function(a){
      if(a.querySelector('[data-wishlist-count]'))return;
      var cs=window.getComputedStyle(a);
      if(cs&&cs.position==='static'){a.style.position='relative';}
      var badge=document.createElement('span');
      badge.className='nty-wishlink__count';
      badge.setAttribute('data-wishlist-count','');
      badge.textContent=count();
      a.appendChild(badge);
    });
    return links.length>0;
  }

  // Injecte un lien SEULEMENT si aucun lien wishlist n'existe dans le header.
  function injectHeaderLink(){
    /* 03/09 — DESACTIVE. Ce script recreait tout seul un lien wishlist dans le header
       et dans le menu quand il n'en trouvait pas : retirer le bouton du theme ne
       servait donc a rien, il repoussait a chaque chargement. On sort tout de suite.
       Le reste du fichier (coeurs de la fiche produit) est intact. */
    return true;
    if(document.querySelector('a[href*="/pages/wishlist"]'))return true;
    var scope=document.querySelector('header#mzHeader')||document.querySelector('header-component')||document.querySelector('header');
    if(!scope)return false;
    var cartIcon=scope.querySelector('a.mz-action--cart,a[href="/cart"],a[href*="/cart"],cart-icon,.cart-bubble');
    var anchor=cartIcon?(cartIcon.closest('a')||cartIcon):null;
    var parent=anchor?anchor.parentNode:scope.querySelector('.mz-actions,.header__actions,.header-actions,[class*="actions"]');
    if(!parent)return false;
    var link=document.createElement('a');
    link.href='/pages/wishlist';link.className='nty-wishlink';link.setAttribute('aria-label','Ma wishlist');
    link.innerHTML='<svg viewBox="0 0 24 24"><path d="M12 21C12 21 3 14.5 3 8.5C3 5.42 5.42 3 8.5 3C10.24 3 11.91 3.81 13 5.08C14.09 3.81 15.76 3 17.5 3C20.58 3 23 5.42 23 8.5C23 14.5 12 21 12 21Z"/></svg><span class="nty-wishlink__count" data-wishlist-count>0</span>';
    if(anchor&&anchor.parentNode===parent){parent.insertBefore(link,anchor);}else{parent.appendChild(link);}
    return true;
  }

  function ensureHeader(){ if(!decorateExistingLinks()){injectHeaderLink();} }

  // Injecte un lien « Ma wishlist » dans le menu hamburger mobile (#ntydDrawer), style natif.
  function injectDrawerLink(){
    /* 03/09 — DESACTIVE. Ce script recreait tout seul un lien wishlist dans le header
       et dans le menu quand il n'en trouvait pas : retirer le bouton du theme ne
       servait donc a rien, il repoussait a chaque chargement. On sort tout de suite.
       Le reste du fichier (coeurs de la fiche produit) est intact. */
    return true;
    var drawer=document.getElementById('ntydDrawer');
    if(!drawer)return false;
    if(drawer.querySelector('a[href="/pages/wishlist"],a[href*="/pages/wishlist"]'))return true;
    var root=drawer.querySelector('.ntyd-panel--root');
    if(!root)return false;
    var groups=root.querySelectorAll('.ntyd-links');
    var container=groups.length?groups[groups.length-1]:root;
    var a=document.createElement('a');
    a.className='ntyd-link';
    a.href='/pages/wishlist';
    a.innerHTML='<svg class="ntyg-ico" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M10 16.6s-5.8-4.2-5.8-7.9A3.35 3.35 0 0 1 10 6.3a3.35 3.35 0 0 1 5.8 2.4c0 3.7-5.8 7.9-5.8 7.9z" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/></svg><span>Ma wishlist</span><svg class="ntyd-link__arrow" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M1 8h13M9 3l5 5-5 5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    container.appendChild(a);
    return true;
  }

  // ===== Cœur FICHE PRODUIT (.mz-wishlist-btn-*) : rendu fonctionnel + persistant =====
  function currentHandle(){
    var m=(location.pathname||'').match(/\/products\/([^\/?#]+)/);
    return m?m[1]:null;
  }
  var pdpData=null;
  function ensurePdpData(handle,cb){
    if(pdpData&&pdpData.handle===handle){cb(pdpData);return;}
    fetch('/products/'+handle+'.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(p){
      pdpData={handle:p.handle,title:p.title,image:(p.featured_image||(p.images&&p.images[0])||''),price:p.price};cb(pdpData);
    }).catch(function(){cb({handle:handle,title:document.title,image:'',price:0});});
  }
  function wirePDP(){
    var handle=currentHandle();if(!handle)return;
    var btns=document.querySelectorAll('[id^="mzWishlist-"]:not([data-nty-pdp]),[class*="mz-wishlist-btn-"]:not([data-nty-pdp])');
    if(!btns.length)return;
    function inWL(){return getWL().some(function(p){return p.handle===handle;});}
    function apply(){var on=inWL();document.querySelectorAll('[data-nty-pdp]').forEach(function(b){b.classList.toggle('active',on);});}
    btns.forEach(function(orig){
      var b=orig.cloneNode(true); // retire le listener cosmétique d'origine
      b.setAttribute('data-nty-pdp','1');
      orig.parentNode.replaceChild(b,orig);
      b.addEventListener('click',function(e){
        e.preventDefault();e.stopPropagation();
        ensurePdpData(handle,function(d){
          var wl=getWL(),i=wl.findIndex(function(p){return p.handle===handle;});
          if(i>-1){wl.splice(i,1);}else{wl.push({handle:d.handle,title:d.title,image:d.image,price:d.price,variant_title:''});}
          saveWL(wl);apply();
          window.dispatchEvent(new CustomEvent('mz:wishlist:updated',{detail:{handle:handle,added:i<0}}));
        });
      });
    });
    apply();
  }

  function refresh(){syncHearts();updateCount();}
  function ensureNav(){ensureHeader();injectDrawerLink();}
  function boot(){refresh();ensureNav();wirePDP();}

  var tries=0;
  function retry(){
    ensureNav();updateCount();
    if(tries++<20)setTimeout(retry,300);
  }

  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot);}else{boot();}
  window.addEventListener('load',function(){refresh();ensureNav();wirePDP();});
  window.addEventListener('mz:wishlist:updated',refresh);
  window.addEventListener('mz:products:rendered',refresh);
  window.addEventListener('storage',function(e){if(e.key===KEY){refresh();}});
  setTimeout(retry,300);

  // Observateur des cartes ajoutées en AJAX (recherche, scroll infini, recos).
  // 2026-08-20 : anti-réentrance (busy) + anti-rafale (rAF) + on ignore nos propres badges.
  var t=null, busy=false;
  function fromOurBadge(rec){
    var tgt=rec.target;
    if(!tgt||!tgt.closest) return false;
    return !!tgt.closest('[data-wishlist-count],.nty-wishlink');
  }
  document.addEventListener('DOMContentLoaded',function(){
    var obs=new MutationObserver(function(m){
      if(busy) return;
      for(var i=0;i<m.length;i++){
        if(m[i].addedNodes && m[i].addedNodes.length && !fromOurBadge(m[i])){
          if(t)clearTimeout(t);
          t=setTimeout(function(){
            requestAnimationFrame(function(){
              busy=true;
              try{ syncHearts();ensureNav();wirePDP();updateCount(); }catch(e){}
              busy=false;
            });
          },250);
          break;
        }
      }
    });
    obs.observe(document.body,{childList:true,subtree:true});
  });
})();
